import moment from 'moment';

export default (date) => {
  const today = moment();
  const dateToCheck = moment(date);

  return today.isAfter(dateToCheck);
};
